import posthog from "./posthog";

function userProps(user) {
  return {
    user_id: user.user_id,
    email: user.email,
    created_at: user.created_at || null,
  };
}

export function identifyUser(user) {
  if (!user?.user_id) return;
  posthog.identify(user.user_id, userProps(user));
}

export function captureSignupCompleted(user) {
  identifyUser(user);
  posthog.capture("Signup Completed", userProps(user));
}

export function capturePaymentSuccess(user, planId, paymentId) {
  identifyUser(user);
  posthog.capture("Payment Success", {
    ...userProps(user),
    plan: planId,
    payment_id: paymentId,
  });
}

export function resetAnalytics() {
  posthog.reset();
}
